import { useState } from 'react';

export const useLinkListMarkErrored = (): {
    erroredIndices: Set<number>;
    markErrored: (idx: number) => void;
} => {
	const [erroredIndices, setErroredIndices] = useState<Set<number>>(new Set());
	const markErrored = (idx: number): void => setErroredIndices((prev) => new Set(prev).add(idx));
	return { erroredIndices, markErrored };
};
